module.exports = __webpack_public_path__ + "img/bizztech.dcbcdebd.png";